"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fsPromise = _interopRequireDefault(require("./fs-promise"));

var _path = _interopRequireDefault(require("path"));

var _uuid = require("uuid");

var _directBinaryUpload = _interopRequireDefault(require("./direct-binary-upload"));

var _directBinaryUploadProcess = _interopRequireDefault(require("./direct-binary-upload-process"));

var _filesystemUploadOptions = _interopRequireDefault(require("./filesystem-upload-options"));

var _utils = require("./utils");

var _httpUtils = require("./http-utils");

var _uploadError = _interopRequireDefault(require("./upload-error"));

var _errorCodes = _interopRequireDefault(require("./error-codes"));

var _uploadResult = _interopRequireDefault(require("./upload-result"));

var _httpClient = _interopRequireDefault(require("./http/http-client"));

var _concurrentQueue = _interopRequireDefault(require("./concurrent-queue"));

var _partUploader = _interopRequireDefault(require("./part-uploader"));

var _httpRequest = _interopRequireDefault(require("./http/http-request"));

var _filesystemUploadUtils = require("./filesystem-upload-utils");

var _filesystemUploadItemManager = _interopRequireDefault(require("./filesystem-upload-item-manager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Uploads one or more files from the local file system to a target AEM instance using direct binary access.
 */
var FileSystemUpload = /*#__PURE__*/function (_DirectBinaryUpload) {
  _inherits(FileSystemUpload, _DirectBinaryUpload);

  var _super = _createSuper(FileSystemUpload);

  function FileSystemUpload() {
    _classCallCheck(this, FileSystemUpload);

    return _super.apply(this, arguments);
  }

  _createClass(FileSystemUpload, [{
    key: "upload",

    /**
     * Retrieves information from the local file system for a list of files, creates a new directory in
     * AEM, then uploads each of the local files to the new directory using direct binary access.
     *
     * @param {DirectBinaryUploadOptions} options Controls how the upload process behaves.
     * @param {Array} localPaths List of local paths to upload. If a path is a directory then its
     *  files will be retrieved and added to the upload.
     * @returns {Promise} Will be resolved when all the files have been uploaded. The data
     *  passed in successful resolution will be an instance of UploadResult.
     */
    value: function () {
      var _upload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options, localPaths) {
        var _this = this;

        var fileSystemUploadOptions, uploadOptions, httpClient, concurrentQueue, partUploader, uploadResult, _yield$this$getUpload, directories, files, errors, totalSize, uploadId, uploadEventData, uploadFiles, fileUploadOptions, uploadProcess;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fileSystemUploadOptions = _filesystemUploadOptions.default.fromOptions(options);
                uploadOptions = this.getOptions();
                httpClient = new _httpClient.default(uploadOptions, fileSystemUploadOptions);
                concurrentQueue = new _concurrentQueue.default(uploadOptions, fileSystemUploadOptions);
                partUploader = new _partUploader.default(uploadOptions, fileSystemUploadOptions, httpClient, concurrentQueue);
                uploadResult = new _uploadResult.default(uploadOptions, fileSystemUploadOptions);
                _context.next = 8;
                return this.createTargetFolder(fileSystemUploadOptions, httpClient);

              case 8:
                _context.next = 10;
                return this.getUploadInformation(fileSystemUploadOptions, localPaths);

              case 10:
                _yield$this$getUpload = _context.sent;
                directories = _yield$this$getUpload.directories;
                files = _yield$this$getUpload.files;
                errors = _yield$this$getUpload.errors;
                totalSize = _yield$this$getUpload.totalSize;
                this.logInfo("From ".concat(localPaths.length, " paths, filesystem upload compiled upload of ").concat(directories.length, " directories, ").concat(files.length, " files, with a total size of ").concat(totalSize, ". Encountered ").concat(errors.length, " filesystem-related errors."));
                uploadId = (0, _uuid.v4)();
                uploadEventData = {
                  uploadId: uploadId,
                  fileCount: files.length,
                  directoryCount: directories.length,
                  totalSize: totalSize
                };
                this.sendEvent('fileuploadstart', uploadEventData);
                _context.next = 21;
                return this.createUploadDirectories(fileSystemUploadOptions, httpClient, directories);

              case 21:
                uploadFiles = this.convertToUploadFilesWithUrl(fileSystemUploadOptions, files);
                this.logInfo("Uploading ".concat(uploadFiles.length, " files")); // initiate the upload process

                fileUploadOptions = _filesystemUploadOptions.default.fromOptions(fileSystemUploadOptions).withUploadFiles(uploadFiles);
                uploadProcess = new _directBinaryUploadProcess.default(this.getOptions(), fileUploadOptions, httpClient, partUploader);
                uploadProcess.on('filestart', function (data) {
                  return _this.sendEvent('filestart', data);
                });
                uploadProcess.on('fileprogress', function (data) {
                  return _this.sendEvent('fileprogress', data);
                });
                uploadProcess.on('fileend', function (data) {
                  return _this.sendEvent('fileend', data);
                });
                uploadProcess.on('fileerror', function (data) {
                  return _this.sendEvent('fileerror', data);
                });
                uploadProcess.on('filecancelled', function (data) {
                  return _this.sendEvent('filecancelled', data);
                });
                _context.prev = 30;
                _context.next = 33;
                return uploadProcess.upload(uploadResult);

              case 33:
                _context.next = 38;
                break;

              case 35:
                _context.prev = 35;
                _context.t0 = _context["catch"](30);
                uploadResult.addUploadError(_context.t0);

              case 38:
                this.sendEvent('fileuploadend', _objectSpread({}, uploadEventData, {
                  result: uploadResult.toJSON()
                })); // we have a list of multiple results (for each directory upload). Merge all those
                // into a single result that contains metrics for the overall upload of all
                // directories and files.

                return _context.abrupt("return", uploadResult);

              case 40:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[30, 35]]);
      }));

      function upload(_x, _x2) {
        return _upload.apply(this, arguments);
      }

      return upload;
    }()
    /**
     * Converts a list of FileSystemUploadAsset instances to a list of UploadFile items, ready
     * for use in upload options.
     * @param {FileSystemUploadOptions} options Options for the upload.
     * @param {Array} files List of FileSystemUploadAsset instances.
     * @returns {Array} List of files ready for use with DirectBinaryUploadOptions.withUploadFiles().
     */

  }, {
    key: "convertToUploadFiles",
    value: function convertToUploadFiles(options, files) {
      var fileList = [];
      files.forEach(function (file) {
        fileList.push(_objectSpread({}, options.getUploadFileOptions(), {
          fileName: file.getRemoteNodeName(),
          filePath: file.getLocalPath(),
          fileSize: file.getSize()
        }));
      });
      return fileList;
    }
    /**
     * Converts a list of FileSystemUploadAsset instances to a list of UploadFile items, ready
     * for use in upload options. The file options generated by this method will include a
     * "fileUrl" property instead of a "fileName" property.
     * @param {DirectBinaryUploadOptions} options Options controlling the upload.
     * @param {Array} files List of FileSystemUploadAsset instances.
     * @returns {Array} List of files ready for use with DirectBinaryUploadOptions.withUploadFiles().
     */

  }, {
    key: "convertToUploadFilesWithUrl",
    value: function convertToUploadFilesWithUrl(options, files) {
      var fileList = [];
      files.forEach(function (file) {
        fileList.push(_objectSpread({}, options.getUploadFileOptions(), {
          fileUrl: "".concat(file.getParentRemoteUrl(), "/").concat(encodeURIComponent(file.getRemoteNodeName())),
          filePath: file.getLocalPath(),
          fileSize: file.getSize()
        }));
      });
      return fileList;
    }
    /**
     * Iterates over a list of local paths provided to the upload. If a path is a file, it will
     * be added to a master list of all paths to upload. If a path is a directory, the method
     * will (recursively) iterate over all descendent directories and files in the path and add
     * them to the master list of paths to upload.
     * @param {DirectBinaryUploadOptions} options Controls how the upload behaves. Will be used to
     *  determine the maximum number of files to upload.
     * @param {Array} localPaths List of local paths to iterate.
     * @returns {object} Aggregated information about all paths to be included in the upload. Has
     *  the following elements:
     *  * {Array} directories: List of full paths to all directories included in the upload.
     *  * {Array} files: List of full paths to all files included in the upload.
     *  * {Array} errors: List of any errors that occurred during processing, which may result in
     *    some paths being excluded from the final result.
     *  * {number} totalSize: Size, in bytes, of all files included in the upload.
     *  * {boolean} isDirectory: True if the path is a directory, false otherwise.
     */

  }, {
    key: "getUploadInformation",
    value: function () {
      var _getUploadInformation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(options, localPaths) {
        var allFiles, allDirectories, allErrors, allTotalSize, isDeep, i, currPath, stat, _yield$walkDirectory, directories, files, errors, totalSize, itemManager, subDirectories, directoryIndex, dirPath, subAssets, assetIndex, _files$assetIndex, filePath, fileSize, _itemManager, maxFileCount;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                allFiles = [];
                allDirectories = [];
                allErrors = [];
                allTotalSize = 0;
                isDeep = (0, _filesystemUploadUtils.isDeepUpload)(options);
                i = 0;

              case 6:
                if (!(i < localPaths.length)) {
                  _context2.next = 79;
                  break;
                }

                currPath = localPaths[i];

                if ((0, _utils.isTempPath)(currPath)) {
                  _context2.next = 73;
                  break;
                }

                stat = false;
                _context2.prev = 10;
                _context2.next = 13;
                return _fsPromise.default.stat(localPaths[i]);

              case 13:
                stat = _context2.sent;
                _context2.next = 20;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](10);
                allErrors.push(_context2.t0);
                return _context2.abrupt("continue", 76);

              case 20:
                if (!stat.isDirectory()) {
                  _context2.next = 65;
                  break;
                }

                _context2.next = 23;
                return (0, _utils.walkDirectory)(currPath, (0, _filesystemUploadUtils.getMaxFileCount)(options), isDeep);

              case 23:
                _yield$walkDirectory = _context2.sent;
                directories = _yield$walkDirectory.directories;
                files = _yield$walkDirectory.files;
                errors = _yield$walkDirectory.errors;
                totalSize = _yield$walkDirectory.totalSize;
                itemManager = new _filesystemUploadItemManager.default(options, currPath, !isDeep);

                if (!isDeep) {
                  _context2.next = 48;
                  break;
                }

                _context2.t1 = allDirectories;
                _context2.next = 33;
                return itemManager.getDirectory(currPath);

              case 33:
                _context2.t2 = _context2.sent;

                _context2.t1.push.call(_context2.t1, _context2.t2);

                subDirectories = [];
                directoryIndex = 0;

              case 37:
                if (!(directoryIndex < directories.length)) {
                  _context2.next = 47;
                  break;
                }

                dirPath = directories[directoryIndex].path;
                _context2.t3 = subDirectories;
                _context2.next = 42;
                return itemManager.getDirectory(dirPath);

              case 42:
                _context2.t4 = _context2.sent;

                _context2.t3.push.call(_context2.t3, _context2.t4);

              case 44:
                directoryIndex++;
                _context2.next = 37;
                break;

              case 47:
                allDirectories = allDirectories.concat(subDirectories);

              case 48:
                subAssets = [];
                assetIndex = 0;

              case 50:
                if (!(assetIndex < files.length)) {
                  _context2.next = 60;
                  break;
                }

                _files$assetIndex = files[assetIndex], filePath = _files$assetIndex.path, fileSize = _files$assetIndex.size;
                _context2.t5 = subAssets;
                _context2.next = 55;
                return itemManager.getAsset(filePath, fileSize);

              case 55:
                _context2.t6 = _context2.sent;

                _context2.t5.push.call(_context2.t5, _context2.t6);

              case 57:
                assetIndex++;
                _context2.next = 50;
                break;

              case 60:
                allFiles = allFiles.concat(subAssets);
                allErrors = allErrors.concat(errors);
                allTotalSize += totalSize;
                _context2.next = 73;
                break;

              case 65:
                if (!stat.isFile()) {
                  _context2.next = 73;
                  break;
                }

                _itemManager = new _filesystemUploadItemManager.default(options, currPath);
                _context2.t7 = allFiles;
                _context2.next = 70;
                return _itemManager.getAsset(currPath, stat.size);

              case 70:
                _context2.t8 = _context2.sent;

                _context2.t7.push.call(_context2.t7, _context2.t8);

                allTotalSize += stat.size;

              case 73:
                maxFileCount = (0, _filesystemUploadUtils.getMaxFileCount)(options);

                if (!(allFiles.length > maxFileCount)) {
                  _context2.next = 76;
                  break;
                }

                throw new _uploadError.default("File system upload has exceeded maximum of ".concat(maxFileCount, " allowed files"), _errorCodes.default.TOO_LARGE);

              case 76:
                i++;
                _context2.next = 6;
                break;

              case 79:
                return _context2.abrupt("return", {
                  directories: allDirectories,
                  files: allFiles,
                  errors: allErrors,
                  totalSize: allTotalSize
                });

              case 80:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[10, 16]]);
      }));

      function getUploadInformation(_x3, _x4) {
        return _getUploadInformation.apply(this, arguments);
      }

      return getUploadInformation;
    }()
    /**
     * Given path information for a local path upload, creates all the directories required to
     * complete the upload. The method will iterate all of the paths in the given information,
     * create the path itself if it's a directory, and create all of of descendent directories.
     * @param {DirectBinaryUploadOptions} options Target folder information used to determine
     *  location where directories should be created.
     * @param {HttpClient} httpClient Client to use to submit HTTP requests.
     * @param {Array} directories An array of FileSystemUploadDirectory instances for the
     *  directories to be created.
     */

  }, {
    key: "createUploadDirectories",
    value: function () {
      var _createUploadDirectories = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(options, httpClient, directories) {
        var i;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                i = 0;

              case 1:
                if (!(i < directories.length)) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 4;
                return this.createAemFolderFromFileSystemInfo(options, httpClient, directories[i]);

              case 4:
                i++;
                _context3.next = 1;
                break;

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function createUploadDirectories(_x5, _x6, _x7) {
        return _createUploadDirectories.apply(this, arguments);
      }

      return createUploadDirectories;
    }()
    /**
     * Creates the target folder from upload options and all of its parents if they do not already exist.
     * @param {DirectBinaryUploadOptions} options Options controlling how the upload process behaves.
     * @param {HttpClient} httpClient Client to use to submit HTTP requests.
     * @returns {Promise} Will be resolved if the folders are created successfully, otherwise will be
     *  rejected with an error.
     */

  }, {
    key: "createTargetFolder",
    value: function () {
      var _createTargetFolder = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(options, httpClient) {
        var targetFolder, trimmedFolder, currPath, paths, i;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                targetFolder = options.getTargetFolderPath();
                trimmedFolder = (0, _utils.trimContentDam)(targetFolder);

                if (!trimmedFolder) {
                  _context4.next = 13;
                  break;
                }

                currPath = '/content/dam';
                paths = String(trimmedFolder).split('/').filter(function (e) {
                  return e.length;
                });
                i = 0;

              case 6:
                if (!(i < paths.length)) {
                  _context4.next = 13;
                  break;
                }

                currPath += "/".concat(paths[i]);
                _context4.next = 10;
                return this.createAemFolder(options, httpClient, currPath);

              case 10:
                i += 1;
                _context4.next = 6;
                break;

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function createTargetFolder(_x8, _x9) {
        return _createTargetFolder.apply(this, arguments);
      }

      return createTargetFolder;
    }()
    /**
     * Creates a folder in AEM if it does not already exist.
     *
     * @param {DirectBinaryUploadOptions} options Options controlling how the upload process behaves.
     * @param {HttpClient} httpClient Client to use to submit HTTP requests.
     * @param {FileSystemUploadDirectory} uploadDirectory Information about the directory
     *  to be created. The instance's remote URL will be used for creation.
     * @returns {Promise} Will be resolved if the folder is created successfully, otherwise will be rejected
     *  with an error.
     */

  }, {
    key: "createAemFolderFromFileSystemInfo",
    value: function () {
      var _createAemFolderFromFileSystemInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(options, httpClient, uploadDirectory) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.createAemFolder(options, httpClient, uploadDirectory.getRemotePath(), uploadDirectory.getName()));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function createAemFolderFromFileSystemInfo(_x10, _x11, _x12) {
        return _createAemFolderFromFileSystemInfo.apply(this, arguments);
      }

      return createAemFolderFromFileSystemInfo;
    }()
    /**
     * Creates a folder in AEM if it does not already exist.
     *
     * @param {DirectBinaryUploadOptions} options Options controlling how the upload process behaves.
     * @param {HttpClient} httpClient Client to use to submit HTTP requests.
     * @param {string} [folderPath] If specified, the path of the folder to create. If not specified, the
     *  target folder in the provided options will be used.
     * @param {string} [folderTitle] If specified, the value to use as the title of the folder. If not
     *  specified then the value will be derived from the folder's path.
     * @returns {Promise} Will be resolved if the folder is created successfully, otherwise will be rejected
     *  with an error.
     */

  }, {
    key: "createAemFolder",
    value: function () {
      var _createAemFolder = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(options, httpClient) {
        var folderPath,
            folderTitle,
            targetFolder,
            trimmedFolder,
            folderName,
            createFolderRequest,
            response,
            _args6 = arguments;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                folderPath = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : '';
                folderTitle = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : '';
                targetFolder = folderPath ? folderPath : options.getTargetFolderPath();
                trimmedFolder = (0, _utils.trimContentDam)(targetFolder);

                if (!trimmedFolder) {
                  _context6.next = 21;
                  break;
                }

                folderName = folderTitle ? folderTitle : _path.default.basename(trimmedFolder);
                _context6.prev = 6;
                this.logInfo("Creating AEM directory ".concat(folderPath, " with title '").concat(folderTitle, "'"));
                createFolderRequest = new _httpRequest.default(this.getOptions(), "".concat(options.getUrlPrefix(), "/api/assets").concat(encodeURI(trimmedFolder))).withMethod(_httpRequest.default.Method.POST).withData({
                  class: 'assetFolder',
                  properties: {
                    'jcr:title': folderName
                  }
                }).withUploadOptions(options);
                _context6.next = 11;
                return httpClient.submit(createFolderRequest);

              case 11:
                response = _context6.sent;
                (0, _httpUtils.updateOptionsWithResponse)(options, response);
                _context6.next = 21;
                break;

              case 15:
                _context6.prev = 15;
                _context6.t0 = _context6["catch"](6);

                if (!(_context6.t0 && _context6.t0.code == _errorCodes.default.ALREADY_EXISTS)) {
                  _context6.next = 20;
                  break;
                }

                this.logInfo("AEM folder '".concat(targetFolder, "' already exists"));
                return _context6.abrupt("return");

              case 20:
                throw _context6.t0;

              case 21:
                this.logInfo("AEM folder '".concat(targetFolder, "' is created"));

              case 22:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[6, 15]]);
      }));

      function createAemFolder(_x13, _x14) {
        return _createAemFolder.apply(this, arguments);
      }

      return createAemFolder;
    }()
  }]);

  return FileSystemUpload;
}(_directBinaryUpload.default);

exports.default = FileSystemUpload;